<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <v-avatar v-bind="attrs" :size="size" :class="avatarClass" v-on="on">
        <span>{{ text }}</span>
      </v-avatar>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'TooltipAvatar',
    props: {
      text: {
        type: [Number, String],
        required: true,
      },
      tooltipText: {
        type: [Number, String],
        required: true,
      },
      avatarClass: {
        type: String,
        default: '',
      },
      size: {
        type: [Number, String],
        default: 22,
      },
    },
  };
</script>
